import type { ReactNode } from 'react'
import { AlertIcon, CheckIcon, InfoIcon, OfflineIcon, WarningIcon } from '@/components/icons'
import { cx } from './internal/cx'
import './StatusCard.css'

export type StatusCardStatus = 'success' | 'warning' | 'error' | 'info' | 'offline'

export type StatusCardProps = {
  status: StatusCardStatus
  title: string
  body?: string
  /** Optional action rendered below the body (e.g. a Button). */
  action?: ReactNode
}

const STATUS_ICON: Record<StatusCardStatus, ReactNode> = {
  success: <CheckIcon size={20} />,
  warning: <WarningIcon size={20} />,
  error: <AlertIcon size={20} />,
  info: <InfoIcon size={20} />,
  offline: <OfflineIcon size={20} />,
}

/** Status card: icon + visible text, never color alone (contract §1). */
export function StatusCard({ status, title, body, action }: StatusCardProps) {
  return (
    <div className={cx('ui-status-card', `ui-status-card--${status}`)} role="status">
      <span className="ui-status-card__icon">{STATUS_ICON[status]}</span>
      <div className="ui-status-card__content">
        <p className="ui-status-card__title">{title}</p>
        {body && <p className="ui-status-card__body">{body}</p>}
        {action && <div className="ui-status-card__action">{action}</div>}
      </div>
    </div>
  )
}
